/**
 * @fileoverview Defines the `Ignorer` interface and `AwolfIgnorer` class for filtering files based on `.awignore` files and directory context. Includes `AlphaWolfIgnorer` to skip `.awignore` files and the awolf directory. The `AwolfIgnorer` class extends `DirectoryIgnorer` to compose multiple `Ignorer` instances.
 */

import { DirectoryIgnorer, IgnoreFileIgnorer, Ignorer } from '@iterator/shared-node/util/ignore'
import { SparsePath } from '@iterator/shared-node/util/sparse_path'
import * as fs from 'fs'
import { AWOLF_DIRECTORY_NAME } from './awolf_dir'

export class AlphaWolfIgnorer implements Ignorer {
  shouldSkip(path: string): boolean {
    return path.includes('.awignore') || path.includes(AWOLF_DIRECTORY_NAME)
  }
}

/**
 * Add custom awolf ignorers on top of the default ignorers.
 */
export class AwolfIgnorer extends DirectoryIgnorer {
  constructor(sparseDir: SparsePath) {
    super(sparseDir, [new AlphaWolfIgnorer()])
  }

  ignorers(path: string): Ignorer[] {
    const ignorers = super.ignorers(path)
    if (fs.lstatSync(path).isDirectory()) {
      ignorers.push(new IgnoreFileIgnorer(path, process.env.AWIGNORE_FILE || '.awignore'))
    }
    return ignorers
  }
}
